// extracted by mini-css-extract-plugin
export default {"video":"VideoTitle_video__1Z8pi","text":"VideoTitle_text__DiNs1","title":"VideoTitle_title__XaWIh","copy":"VideoTitle_copy__2FWL4","button":"VideoTitle_button__2vKRX"};